import { Dispatch } from "redux";
import {
    setWorkflowTemplateDetailsLoading
} from "@redux/actions/workflow-template-details-actions";
import { getWorkflowTemplateDetailsRequest } from "@requests/management-console/get-workflow-template-details";
import { WorkflowTemplateDetails } from "@idw-types/data/workflow-template-details";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getWorkflowTemplateDetailsReduxRequest = (dispatch: Dispatch) => async (
    workflowTemplateId: string,
    workflowTemplateNotFoundCallback: () => void,
    showError: boolean
): Promise<WorkflowTemplateDetails> => {
    dispatch(setWorkflowTemplateDetailsLoading(true));
    const { data, error } = await getWorkflowTemplateDetailsRequest(workflowTemplateId);

    if (data) {
        return data;
    } else {
        if (error) {
            const errorCode = JSON.parse(error).code;
            if (!showError && errorCode === 404) {
                workflowTemplateNotFoundCallback();
            } else {
                logAndDisplayErrorModal(
                    dispatch,
                    error,
                    resources.requests.getWorkflowTemplateDetails.error.title,
                    resources.requests.getWorkflowTemplateDetails.error.message,
                    error
                );
            }
        }
        dispatch(setWorkflowTemplateDetailsLoading(false));
        return null;
    }
};